import SectionCard from '../components/SectionCard.jsx';

// Small presentational pieces shared by the Data reference page and its
// per-source cards (pages/DataReference.jsx, pages/DataReferenceSource.jsx).

/** One block of the guide: the shared SectionCard, kept addressable by its id (deep links and the contents list). */
export function Card({ id, title, children }) {
  return (
    <SectionCard id={id} title={title} className="scroll-mt-16 lg:scroll-mt-4" bodyClassName="space-y-4">
      {children}
    </SectionCard>
  );
}

export function Bullets({ items }) {
  return (
    <ul className="list-disc pl-5 space-y-1.5 text-sm text-ipc-ink">
      {items.map((t) => <li key={t}>{t}</li>)}
    </ul>
  );
}

export function Term({ children }) {
  return <dt className="font-medium text-ipc-ink">{children}</dt>;
}

export function Desc({ children }) {
  return <dd className="text-ipc-ink min-w-0 [overflow-wrap:anywhere]">{children}</dd>;
}

export function Pair({ term, children }) {
  return (
    <>
      <Term>{term}</Term>
      <Desc>{children}</Desc>
    </>
  );
}

export function Mono({ children }) {
  return <code className="font-mono text-[13px] text-ipc-ink bg-slate-100 rounded px-1 [overflow-wrap:anywhere]">{children}</code>;
}

export function Code({ children }) {
  return (
    <pre className="mt-1 bg-slate-900 text-slate-100 text-xs rounded-md p-3 whitespace-pre-wrap [overflow-wrap:anywhere] font-mono">
      {children}
    </pre>
  );
}

export function References({ refs }) {
  return refs.map((r, i) => (
    <span key={`${r.field}-${r.key}`}>
      {i > 0 && ', '}
      <a href={`#source-${r.key}`} className="text-ipc-light underline hover:no-underline">{r.label}</a>
      {' '}on <Mono>{r.field}</Mono>
    </span>
  ));
}
